import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { Amount } from '@/features/payouts/components/Amount'
import { Emphasize } from '@/features/payouts/components/Emphasize'
import { byDesign } from '@/infra/design'
import imgPaymentMethodsUrl from '@/assets/misc/img_payment-methods.svg'
import NoPaymentMethodsIllustration from '@/components/SpotIllustration/NoPaymentMethodsIllustration'

export interface ConfirmNewTransactionModalProps {
  showing: boolean
  onClose: () => unknown
  onConfirm: () => unknown
  reasonLabel: string
  recipientName: string
  amount: number
}

export function ConfirmNewTransactionModal({
  showing,
  onClose,
  onConfirm,
  reasonLabel,
  recipientName,
  amount,
}: ConfirmNewTransactionModalProps) {
  return (
    <ModalSheet showing={showing} onRequestClose={onClose}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgPaymentMethodsUrl}
            illustration={byDesign(undefined, NoPaymentMethodsIllustration)}
          />
          <ModalSheetContentTitle>
            You are about to add a new transaction
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Are you sure you want to add a <Emphasize>{reasonLabel}</Emphasize>{' '}
            for <Emphasize>{recipientName}</Emphasize>, totalling{' '}
            <Emphasize>
              <Amount value={amount} />
            </Emphasize>
            ?
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button label="Cancel" onPress={onClose} />
          <Button
            label="Confirm Transaction"
            variant="primary"
            onPress={onConfirm}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
